<template>
    <main class="download-wrap">
      <AccountSetLayout layoutType="AccountSet" :layoutTitile="$t('changeTitle')" style="display: none;"></AccountSetLayout>
      <div class="download-content">
        <h1 class="download-title">{{ $t('download_title') }}</h1>
        <div class="download-tips bonus-tips">
          Tips：出于设备安全考虑，下载中心所有镜像均为封闭镜像，不支持登录。开放镜像请前往论坛下载。
        </div>
        <div class="down-line"></div>
        <!-- 安卓APP（绑定 -->
        <section class="download-node">
          <div class="section-wrap">
            <icon class="download-icon android-icon"></icon>
            <span class="section-title">{{ $t('Android') }}</span>
          </div>
          <div class="section-wrap version-wrap">
            <icon class="download-icon info-icon"></icon>
            <p class="version">{{ $t('Version') }}</p>
          </div>
          <div class=" detail-wrap">
            <div class="update-time">{{ $t('Update_Time') }}: 2023-08-22</div>
            <div>MD5: 83e9dfba71c1050d8159e414fc7bfc47</div>
          </div>
          <div class="download-tab" @click="getJDOSSResource('BonusCloud-LiteNode-admin-forPI.apk')">
            <p class="download-button">下载</p>
          </div>
          <!-- <a href="https://bonuscloud-imgs.oss.cn-north-1.jcloudcs.com/BonusCloud-LiteNode-admin-forPI.apk" target="_blank" class="download-tab">
            <span>{{ $t('download') }}</span>
          </a> -->
          <a href="https://play.google.com/store/apps/details?id=io.bonuscloud.app" target="_blank" class="download-tab second-tab">
            <span>Google Play</span>
          </a>
        </section>
        <!-- X86镜像 (OVA 适用于VMWare、群晖等虚拟机安装) -->
        <section class="download-node">
          <div class="section-wrap">
            <icon class="download-icon x86-icon"></icon>
            <span class="section-title">{{ $t('X86') }} (OVA 适用于VMWare、群晖等虚拟机安装)</span>
          </div>
          <div class="section-wrap version-wrap">
            <icon class="download-icon info-icon"></icon>
            <p class="version">{{ $t('Version') }}</p>
          </div>
          <div class=" detail-wrap">
            <div class="update-time">{{ $t('Update_Time') }}: 2023-08-17</div>
            <div>MD5: c881e22bde78aa66f22077591825d4c5</div>
          </div>
          <div class="download-tab" @click="getJDOSSResource('BonusCloud-LiteNode-x86.ova.tar.gz')">
            <p class="download-button">下载</p>
          </div>
          <!-- <a href="https://bonuscloud-imgs.s3.cn-north-1.jdcloud-oss.com/BonusCloud-LiteNode-x86.ova" target="_blank" class="download-tab">
            <span>{{ $t('download') }}</span>
          </a> -->
          <a href="https://bonuscloud.club/viewtopic.php?f=52&t=5029" target="_blank" class="download-tab second-tab">
            <span>{{ $t('Tutorial') }}</span>
          </a>
        </section>
        <!-- X86镜像(适用于ESXi) -->
        <section class="download-node">
          <div class="section-wrap">
            <icon class="download-icon x86-icon"></icon>
            <span class="section-title">{{ $t('X86') }} (适用于ESXi)</span>
          </div>
          <div class="section-wrap version-wrap">
            by 网络安全工程师
          </div>
          <div class="section-wrap version-wrap">
            <icon class="download-icon info-icon"></icon>
            <p class="version">{{ $t('Version') }}</p>
          </div>
          <div class=" detail-wrap">
            <div class="update-time">{{ $t('Update_Time') }}: 2023-08-17</div>
            <div>MD5: f93a344a6dd8d918d14a3edc8d1d0bae</div>
          </div>
          <div class="download-tab" @click="getJDOSSResource('ESXi-bxc-centos7-20230817-封闭版-网络安全工程师.ova')">
            <p class="download-button">下载</p>
          </div>
          <!-- <a href="https://bonuscloud-imgs.s3.cn-north-1.jdcloud-oss.com/ESXi-bxc-centos7-20200528-%E5%B0%81%E9%97%AD%E7%89%88-%E7%BD%91%E7%BB%9C%E5%AE%89%E5%85%A8%E5%B7%A5%E7%A8%8B%E5%B8%88.ova" target="_blank" class="download-tab">
            <span>{{ $t('download') }}</span>
          </a> -->
          <a href="https://bonuscloud.club/viewtopic.php?f=52&t=13083" target="_blank" class="download-tab second-tab">
            <span>{{ $t('Tutorial') }}</span>
          </a>
        </section>
        <!-- X86镜像(Hyper-v) -->
        <section class="download-node">
          <div class="section-wrap">
            <icon class="download-icon x86-icon"></icon>
            <span class="section-title">{{ $t('X86') }} (适用于Hyper-v)</span>
          </div>
          <div class="section-wrap version-wrap">
            by 网络安全工程师
          </div>
          <div class="section-wrap version-wrap">
            <icon class="download-icon info-icon"></icon>
            <p class="version">{{ $t('Version') }}</p>
          </div>
          <div class=" detail-wrap">
            <div class="update-time">{{ $t('Update_Time') }}: 2020-06-02</div>
            <div>MD5: 3a50e2647c69639dd13427ddbca988a0</div>
          </div>
          <div class="download-tab" @click="getJDOSSResource('Hyper-v-bxc-centos7-20200528-封闭版-网络安全工程师.zip.2')">
            <p class="download-button">下载</p>
          </div>
          <!-- <a href="https://bonuscloud-imgs.s3.cn-north-1.jdcloud-oss.com/Hyper-v-bxc-centos7-20200528-%E5%B0%81%E9%97%AD%E7%89%88-%E7%BD%91%E7%BB%9C%E5%AE%89%E5%85%A8%E5%B7%A5%E7%A8%8B%E5%B8%88.zip" target="_blank" class="download-tab">
            <span>{{ $t('download') }}</span>
          </a> -->
          <a href="https://bonuscloud.club/viewtopic.php?f=52&t=5513" target="_blank" class="download-tab second-tab">
            <span>{{ $t('Tutorial') }}</span>
          </a>
        </section>
        <!-- X86镜像(适用于PVE) -->
        <section class="download-node">
          <div class="section-wrap">
            <icon class="download-icon x86-icon"></icon>
            <span class="section-title">{{ $t('X86') }} (适用于PVE)</span>
          </div>
          <div class="section-wraiip version-wrap">
            by 网络安全工程师
          </div>
          <div class="section-wrap version-wrap">
            <icon class="download-icon info-icon"></icon>
            <p class="version">{{ $t('Version') }}</p>
          </div>
          <div class=" detail-wrap">
            <div class="update-time">{{ $t('Update_Time') }}: 2023-08-30</div>
            <div>MD5: 88691c3dbb39f970653c9d32abcaf391</div>
          </div>
          <div class="download-tab" @click="getJDOSSResource('vzdump-qemu-2023_08_30-12_06_41.vma.lzo')">
            <p class="download-button">下载</p>
          </div>
          <!-- <a href="https://bonuscloud-imgs.s3.cn-north-1.jdcloud-oss.com/PVE-vzdump-qemu-180-2020_05_28-12_47_39.vma-%E7%BD%91%E7%BB%9C%E5%AE%89%E5%85%A8%E5%B7%A5%E7%A8%8B%E5%B8%88.lzo" target="_blank" class="download-tab">
            <span>{{ $t('download') }}</span>
          </a> -->
          <a href="https://bonuscloud.club/viewtopic.php?f=52&t=5024" target="_blank" class="download-tab second-tab">
            <span>{{ $t('Tutorial') }}</span>
          </a>
        </section>
        <!-- 树莓派 -->
        <section class="download-node">
          <div class="section-wrap">
            <icon class="download-icon cpu-icon"></icon>
            <span class="section-title">{{ $t('RaspberryPi') }}</span>
          </div>
          <div class="section-wrap version-wrap">
            <icon class="download-icon info-icon"></icon>
            <p class="version">{{ $t('Version') }}</p>
          </div>
          <div class=" detail-wrap">
            <div class="update-time">{{ $t('Update_Time') }}：2018-12-11</div>
            <div>MD5: e74f1456538b436716b651ef54c81b8a</div>
          </div>
          <div class="download-tab" @click="getJDOSSResource('BonusCloud-LiteNode-raspberryPi-armv7l-20181210.img.xz')">
            <p class="download-button">下载</p>
          </div>
          <!-- <a href="https://bonuscloud-imgs.oss.cn-north-1.jcloudcs.com/BonusCloud-LiteNode-raspberryPi-armv7l-20181210.img.xz" target="_blank" class="download-tab">
            <span>{{ $t('download') }}</span>
          </a> -->
          <a href="https://bonuscloud.club/viewtopic.php?f=19&t=4216" target="_blank" class="download-tab second-tab">
            <span>{{ $t('Tutorial') }}</span>
          </a>
        </section>
        <!-- N1 -->
        <section class="download-node">
          <div class="section-wrap">
            <icon class="download-icon cpu-icon"></icon>
            <span class="section-title">{{ $t('N1') }}</span>
          </div>
          <div class="section-wrap version-wrap">
            <icon class="download-icon info-icon"></icon>
            <p class="version">{{ $t('Version') }}</p>
          </div>
          <div class=" detail-wrap">
            <div class="update-time">{{ $t('Update_Time') }}：2024-07-23</div>	
            <div>MD5: 86bb671be6c40a9b94c9cfe180710a21</div>
          </div>
          <div class="download-tab" @click="getJDOSSResource('BonusCloud-Lite_24.5.0_amlogic_s905d_jammy_6.6.38_20240711.img.tar.gz')">
            <p class="download-button">下载</p>
          </div>
          <!-- <a href="https://bonuscloud-imgs.s3.cn-north-1.jdcloud-oss.com/BonusCloud-LiteNode-N1-emmc-1-2%2B-2.img.tar.gz" target="_blank" class="download-tab">
            <span>{{ $t('download') }}</span>
          </a> -->
          <a href="https://bonuscloud.club/viewtopic.php?f=48&t=690" target="_blank" class="download-tab second-tab">
            <span>{{ $t('Tutorial') }}</span>
          </a>
        </section>
        <!-- R3300L -->
        <section class="download-node">
          <div class="section-wrap">
            <icon class="download-icon cpu-icon"></icon>
            <span class="section-title">R3300L </span>
          </div>
          <div class="section-wrap version-wrap">
            <icon class="download-icon info-icon"></icon>
            <p class="version">{{ $t('Version') }}</p>
          </div>
          <div class=" detail-wrap">
            <div class="update-time">{{ $t('Update_Time') }}：2020-09-10</div>	
            <div>MD5: 7ff1f27daafae2acfc95fba8e9c0aa7e</div>
          </div>
          <div class="download-tab" @click="getJDOSSResource('BonusCloud-LiteNode-R3300-L-emmc-20200907.img.xz')">
            <p class="download-button">下载</p>
          </div>
          <!-- <a href="https://bonuscloud-imgs.s3.cn-north-1.jdcloud-oss.com/BonusCloud-LiteNode-R3300-L-emmc-20200907.img.xz" target="_blank" class="download-tab">
            <span>{{ $t('download') }}</span>
          </a> -->
        </section>
        <!-- 我家云 -->
        <section class="download-node">
          <div class="section-wrap">
            <icon class="download-icon cpu-icon"></icon>
            <span class="section-title">我家云</span>
          </div>
          <div class="section-wraiip version-wrap">
            by 404
          </div> 
          <div class="section-wrap version-wrap">
            <icon class="download-icon info-icon"></icon>
            <p class="version">{{ $t('Version') }}</p>
          </div>
          <div class=" detail-wrap">
            <div class="update-time">{{ $t('Update_Time') }}：2020-06-08</div>	
            <div>MD5: 426153097d6a63ed752697a86638b436</div>
          </div>
          <div class="download-tab" @click="getJDOSSResource('我家云一键刷机包(含驱动) 1.4.0.tar.xz')">
            <p class="download-button">下载</p>
          </div>
          <!-- <a href="https://bonuscloud-imgs.s3.cn-north-1.jdcloud-oss.com/%E6%88%91%E5%AE%B6%E4%BA%91%E4%B8%80%E9%94%AE%E5%88%B7%E6%9C%BA%E5%8C%85%28%E5%90%AB%E9%A9%B1%E5%8A%A8%29%201.4.0.tar.xz" target="_blank" class="download-tab">
            <span>{{ $t('download') }}</span>
          </a> -->
          <a href="https://bonuscloud.club/viewtopic.php?f=54&t=5891" target="_blank" class="download-tab second-tab">
            <span>{{ $t('Tutorial') }}</span>
          </a>
        </section>
        <!-- NanoPi -->
        <section class="download-node">
          <div class="section-wrap">
            <icon class="download-icon cpu-icon"></icon>
            <span class="section-title">{{ $t('NanoPi') }}</span>
          </div>
          <div class="section-wrap version-wrap">
            <icon class="download-icon info-icon"></icon>
            <p class="version">{{ $t('Version') }}</p>
          </div>
          <div class=" detail-wrap">
            <div class="update-time">{{ $t('Update_Time') }}：2018-11-03</div>
            <div>MD5: a4c5d5f3fb4933e4868e88762a9d913a</div>
          </div>
          <div class="download-tab" @click="getJDOSSResource('BonusCloud-LiteNode-nanoPiNeoPlus2-aarch64.tar.bz2')">
            <p class="download-button">下载</p>
          </div>
          <!-- <a href="https://bonuscloud-imgs.oss.cn-north-1.jcloudcs.com/BonusCloud-LiteNode-nanoPiNeoPlus2-aarch64.tar.bz2" target="_blank" class="download-tab">
            <span>{{ $t('download') }}</span>
          </a> -->
          <a href="https://bonuscloud.club/viewtopic.php?f=19&t=4216" target="_blank" class="download-tab second-tab">
            <span>{{ $t('Tutorial') }}</span>
          </a>
        </section>
        <!-- Merlin -->
        <section class="download-node router-node last-node">
          <div class="section-wrap">
            <icon class="download-icon router-icon"></icon>
            <span class="section-title">{{ $t('Merlin') }}</span>
          </div>
          <div class="section-wrap version-wrap">
            <icon class="download-icon info-icon"></icon>
            <p class="version">ARM v7/ARM v8</p>
          </div>
          <a href="https://github.com/BonusCloud/BonusCloud-Node" target="_blank" class="download-tab">
            <span>Github</span>
          </a>
          <a href="https://bonuscloud.club/viewtopic.php?f=15&t=2014" target="_blank" class="download-tab second-tab">
            <span>{{ $t('Tutorial') }}</span>
          </a>
        </section>
        <div class="more-wrap">
          <div class="left-content">
            <p class="text">{{ $t('Des') }}</p>
            <p class="other">{{ $t('Firmware') }}</p>
            <p class="other">{{ $t('CPU') }}</p>
            <p class="other">{{ $t('Brand') }}</p>
          </div>
          <div class="right-content">
            <icon class="download-icon people-icon"></icon>
            <a href="https://bonuscloud.club/index.php" target="_blank" class="go-tab">GO</a>
          </div>
        </div>
      </div>
    </main>
</template>

<script>
import { mapActions, mapState } from "vuex";
import AccountSetLayout from '@/components/AccountSet/AccountSetLayout.vue'
import BasiceLayout from '@/components/Common/BasicLayout.vue'
import Layout from "@/components/DatePanel/Layout.vue";
import { Message } from 'element-ui'

export default {
  name: "download",
  computed: mapState({
    isZnWebsite: state => state.isZnWebsite,
    email: state => state.account.email,
  }),
  components:{
    AccountSetLayout
  },
  created() {
    this.$i18n.locale = this.isZnWebsite ? "zn" : "en";
  },
  methods: {
    ...mapActions(['recordDownloadCenter']),
    getJDOSSResource(type) {
      this.recordDownloadCenter({ resource: type }).then(res=>{
        if(res.code == 200) {
          Message({
            message: '下载成功',
            type: "success",
          })
          window.open(res.data)
        } else {
          return Message({
            message: res.msg,
            type:"error",
          })
        }
      })
    }
  }
};
</script>

<style lang="stylus">
.download-button{
  margin: 0 auto;
}
.down-home.home {
    height: auto!important;
}
.download-wrap
  padding: 20px 20px;
  /* width: 100%; */
  background: #f5f5f5;
.download-content
  padding-top: 80px;
  height: auto;
  /* width: 903px; */
  background: #fff;
  padding: 20px;
  /* text-align left; */
.download-title
  text-align left;
  font-size: 22px;
  font-weight: bold;
  height: 25px;
  line-height: 25px;
  padding: 30px;
.download-icon 
  display: inline-block;
  background-size: cover;
  width: 20px;
  height: 20px;
  margin-right: 10px;
.android-icon 
  background-image: url('../../assets/download/android.png');
.x86-icon 
  background-image: url('../../assets/download/x86.png');
.router-icon
  background-image: url('../../assets/download/router.png');
.cpu-icon
  background-image: url('../../assets/download/CPU.png');
.people-icon
  background-image: url('../../assets/download/people.png');
  width: 60px;
  height:50px;
  margin-bottom: 20px;
.xz-icon
  background-image: url('../../assets/download/download.png');
  width: 15px;
  height: 15px;
  position: absolute;
  left: 10px;
  top: 14px;
  width: 12px;
  height: 12px;
.small-icon
  position: absolute;
  left: 10px;
  top: 14px;
.download-tab span 
  display: block;
  width: 100%;
  text-align: center;
.info-icon
  background-image: url('../../assets/download/i.png');
  width: 15px;
  height: 15px;
  margin: 2.5px;
.section-title 
  line-height: 20px;
  font-weight: bold;
.download-node
  position: relative;
  padding: 30px;
  border-bottom: 1px dashed #e3e3e3;
.section-wrap
  display: flex;
.version-wrap
  padding: 10px 10px 10px 30px;
.detail-wrap 
  padding-left: 60px;
  font-size: 12px;
.update-time
  padding-bottom: 10px;
.download-tab
  display: flex;
  font-weight: bold;
  background-color: #0db4c5;
  width: 100px;
  padding: 10px;
  border-radius: 10px;
  color: #fff;
  font-size: 14px;
  position: absolute;
  right: 30px;
  top: 30px;
.go-tab 
  text-align: center;
  display: block;
  background-color: #0db4c5;
  width: 100px;
  padding: 10px;
  border-radius: 10px;
  color: #fff;
  font-size: 12px;
  text-align: center;
  font-weight: bold;
.second-tab
  display: flex;
  right: 30px;
  top: 80px;
.router-node
  min-height: 100px;
.last-node
  border-bottom: 1px solid #e3e3e3;
.more-wrap
  display: flex;
  margin: 30px;
.left-content .text
  font-size: 16px;
  margin: 10px 10px 30px;
.left-content .other
  margin: 5px 0 10px 50px;
  font-size: 14px;
.left-content
  width: 70%;
.right-content
  width: 30%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
.download-tips
  margin: 0 30px;
  color: #f56c6c;
.down-line
  border-bottom: 1px solid #e3e3e3;
  margin: 10px 30px;
</style>

<style>
  .is-mobile {
    .download-tab {
      position: relative;
      right: 0;
    }
    .second-tab{
      top: -10px;
      right: -140px;
    }
  }
</style>

<i18n>
{
  "en": {
    "download_title": "DOWNLOAD",
    "download": "Download",
    "Android": "Android APP For Binding",
    "Version": "Lastest Version",
    "Update_Time" : "Update Time",
    "X86": "X86 Image File",
    "RaspberryPi": "RaspberryPi Image File",
    "N1": "N1 Image File",
    "NanoPi": "NanoPi Image File",
    "Merlin": "Router Plugin For Merlin",
    "Tutorial": "Tutorial",
    "Des": "Only officially supported firmware or plugins are available here. If you do not find the resources you need, go to the BonusCloud Club for community compatible firmware and technical support.",
    "Firmware": "Router Firmware：OpenWrt/Padavan ...",
    "CPU": "CPU Architecture：MIPS/MIPSEL/ARM v7/ARM v8 ...",
    "Brand": "Designated Brand：PHICOMM/ASUS/XIAOMI/NETGEAR/NewWifi ..."
  },
  "zn": {
    "download_title": "下载中心",
    "download": "下载",
    "Android": "安卓APP（绑定）",
    "Version": "最新版本",
    "Update_Time" : "更新时间",
    "X86": "X86镜像",
    "RaspberryPi": "RaspberryPi镜像",
    "N1": "N1镜像",
    "NanoPi": "NanoPi镜像",
    "Merlin": "梅林路由器插件",
    "Tutorial": "教程",
    "Des": "下载中心仅提供由官方支持发布的固件或插件。 如果找不到所需的资源，请访问BonusCloud Club获取社区兼容的固件和技术支持。",
    "Firmware": "路由器插件：OpenWrt/Padavan 等",
    "CPU": "不同CPU架构：MIPS/MIPSEL/ARM v7/ARM v8 等",
    "Brand": "特定品牌设备：斐讯/华硕/小米/网件/新路由/我家云 等"
  }
}
</i18n>
